<div class="page-layout carded fullwidth">

    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

        <!-- CONTENT HEADER -->
        <div class="header accent p-24" fxLayout="row" fxLayoutAlign="start center">
            <h2 class="m-0">
              <span *ngIf="!editar_nombre" class="px-20">{{analisisDeBrechas?.nombre}}</span>
              <input placeholder="Nombre" matInput [(ngModel)]="nombre" *ngIf="editar_nombre">
              <mat-icon *ngIf="editar_nombre" aria-hidden="false" aria-label="Editar estado" (click)="updateName(nombre)" >save</mat-icon>
              <mat-icon *ngIf="is_eval_creador && analisisDeBrechas?.estado!='CERRADO'" aria-hidden="false" aria-label="Editar nombre" (click)="editar_nombre=true" >edit</mat-icon>
            </h2>

        </div>
        <!-- / CONTENT HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card">

            <!-- CONTENT TOOLBAR -->
            <div class="toolbar px-24 py-8">

                <div>
                  <!--   -->
                  <mat-horizontal-stepper [linear]="true" #stepper [selectedIndex]="this.selectedStatus"
                      (selectionChange)="setIndex($event)"
                      (click)="changeStatus()"
                      style="max-height:60px">
                      <mat-step [editable]="isEditable" [completed]="isThisStepDone0" [state]="isStepDone0">
                        <form [formGroup]="preiniciadoFormGroup">
                          <ng-template matStepLabel>Preiniciado</ng-template>
                          <input matInput  placeholder="Last name, First name" required
                          class="invisible example-full-width"
                          >
                        </form>
                      </mat-step>
                      <mat-step [editable]="isEditable" [completed]="isThisStepDone1" [state]="isStepDone1" >
                        <form [formGroup]="completadoFormGroup" >
                          <ng-template matStepLabel >Completado</ng-template>
                          <input matInput  placeholder="Last name, First name" required
                          class="invisible example-full-width"
                          >
                        </form>
                      </mat-step>
                      <mat-step  [editable]="isEditable" [completed]="isThisStepDone2" [state]="isStepDone2" >
                        <form [formGroup]="cerradoFormGroup">
                          <ng-template matStepLabel >Cerrado</ng-template>
                          <input matInput  placeholder="Last name, First name" required
                          class="invisible example-full-width"
                          >
                        </form>
                      </mat-step>
                  </mat-horizontal-stepper>
                </div>
                <div fxFlex fxLayout="row" fxLayoutAlign="end center">
                  <button  mat-button (click)="viewStatistics(analisisDeBrechas?.marcoDeReferencia,0,false)" mat-flat-button color="primary" class="add-row">
                    <mat-icon  aria-hidden="false" aria-label="statistics" >bar_chart</mat-icon>
                  </button>
                  <button  mat-button (click)="viewStatistics(analisisDeBrechas?.marcoDeReferencia,0,true)" mat-flat-button color="primary" class="add-row" 
                              *ngIf="analisisDeBrechas?.tablaDeAnalisisDeBrechas.tipo=='EVALUACION_MULTIPLE'">
                    <mat-icon  aria-hidden="false" aria-label="statistics" >insert_chart_outlined</mat-icon>
                  </button>
                  <button  mat-button (click)="print()" mat-flat-button color="primary" class="add-row">
                    <mat-icon  aria-hidden="false" aria-label="print" >print</mat-icon>
                  </button>
                  <button *ngIf="(is_responsable || is_eval_creador) && (analisisDeBrechas?.estado=='PRE_INICIADO' || analisisDeBrechas?.estado=='COMPLETADO')" mat-button (click)="copiar()" mat-flat-button color="primary" class="add-row">
                    <mat-icon aria-hidden="false" aria-label="Copiar" >file_copy</mat-icon>
                    Copiar
                  </button>
                  <button *ngIf="(is_eval_creador ) && (analisisDeBrechas?.estado=='COMPLETADO' || analisisDeBrechas?.estado=='APROBADO') " mat-button (click)="rechazar()" mat-flat-button color="primary" class="add-row">
                  <mat-icon *ngIf="(is_eval_creador ) && analisisDeBrechas?.estado=='COMPLETADO'" aria-hidden="false" aria-label="Rechazar" >undo</mat-icon>
                    Rechazar
                  </button>
                  <button  mat-button (click)="navegateTo('/todos-los-analisis-de-brechas','')" mat-flat-button color="primary" class="add-row">
                    <mat-icon  aria-hidden="false" aria-label="Salir" >exit_to_app</mat-icon>
                    Salir
                  </button>

                </div>

            </div>
            <!-- / CONTENT TOOLBAR -->

            <!-- CONTENT -->
            <div class="content p-24" style="max-height: 200px !important;"  >

                <div id="scan" class="p-24" fxLayout="row" xFlex="100">

                    <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="100" fxFlex.gt-md="50">

                        <div class="profile-box info-box general" fxLayout="column">

                          <table class="summary">
                              <tr class="code">
                                  <td class="label">Tabla de evaluación</td>
                                  <td class="value">
                                    <span  class="px-20">{{analisisDeBrechas?.tablaDeAnalisisDeBrechas?.nombre}}</span>
                                    <!--<mat-form-field *ngIf="editar_tabla_de_evaluacion" fxFlex>
                                      <mat-label>Tabla de evaluación</mat-label>
                                      <mat-select [(ngModel)]="analisisDeBrechas.tablaDeAnalisisDeBrechas" class="roleSelect" (selectionChange)="selectTablaDeEvaluacion($event)">
                                          <mat-option *ngFor="let tabla of tablasDeEvaluacion" [value]="tabla">
                                              {{tabla.nombre}}
                                          </mat-option>
                                      </mat-select>
                                    </mat-form-field>
                                    <a *ngIf="(is_eval_creador && analisisDeBrechas?.estado=='PRE_INICIADO')" (click)="editar_tabla_de_evaluacion=true">Editar</a>
                                    <!--<mat-icon *ngIf="(is_owner && analisisDeBrechas?.estado=='PRE_INICIADO') || (is_eval_creador)" aria-hidden="false" aria-label="Editar estado" (click)="editar_tipo=true" >edit</mat-icon>-->
                                  </td>
                              </tr>

                              <tr>
                                  <td class="label">Estructura jerárquica / Nodo</td>
                                  <td class="value">
                                    <span class="px-20" *ngIf="analisisDeBrechas?.estructuraJerarquica!=null">{{analisisDeBrechas?.estructuraJerarquica?.nombre}} / {{analisisDeBrechas?.nodoEstructuraJerarquica?.nombre}}</span>
                                    <a *ngIf="(is_eval_creador && analisisDeBrechas?.estado=='PRE_INICIADO')" (click)="openDialog()">Editar</a>
                                    <!--<mat-icon  aria-hidden="false" aria-label="Editar estado" (click)="openDialog()" >edit</mat-icon>-->
                                  </td>
                              </tr>

                              <tr>
                                  <td class="label">Marco de referencia</td>
                                  <td class="value">
                                    <span *ngIf="!editar_marco_de_referencia" class="px-20">{{analisisDeBrechas?.marcoDeReferencia?.nombre}}</span>
                                    <mat-form-field *ngIf="editar_marco_de_referencia" fxFlex>
                                      <mat-label>Marco de referencia</mat-label>
                                      <mat-select [(ngModel)]="analisisDeBrechas.marcoDeReferencia" class="roleSelect" (selectionChange)="selectMarcoDeReferencia($event)">
                                          <mat-option *ngFor="let marco of marcosDeReferencia" [value]="marco">
                                              {{marco.nombre}}
                                          </mat-option>
                                      </mat-select>
                                    </mat-form-field>
                                    <a *ngIf="(is_eval_creador && analisisDeBrechas?.estado=='INICIADO')" (click)="editar_marco_de_referencia=true">Editar</a>
                                    <!--<mat-icon *ngIf="(is_owner && analisisDeBrechas?.estado=='PRE_INICIADO') || (is_eval_creador)" aria-hidden="false" aria-label="Editar estado" (click)="editar_escenario=true" >edit</mat-icon>-->
                                  </td>
                              </tr>

                          </table>
                        </div>
                    </div>


                    <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="100" fxFlex.gt-md="50">
                      <div class="profile-box info-box general" fxLayout="column">
                        <table class="summary">
                            <tr class="code">
                                <td class="label">Responsable</td>
                                <td class="value">
                                  <span *ngIf="!editar_responsable" class="px-20">{{analisisDeBrechas?.responsable?.nombreCompleto}}</span>
                                  <mat-form-field *ngIf="editar_responsable" fxFlex>
                                    <mat-label>Responsable</mat-label>
                                    <mat-select [(ngModel)]="analisisDeBrechas.responsable" class="roleSelect" (selectionChange)="selectDueno($event)">

                                      <ng-container *ngFor="let usuario of analisisDeBrechas?.nodoEstructuraJerarquica?.usuarios">
                                        <mat-option *ngIf="esEvaluadorGroup(usuario)" [value]="usuario">
                                          {{usuario.nombreCompleto}}
                                        </mat-option>
                                      </ng-container>
                                      <!--
                                        <mat-option *ngFor="let usuario of analisisDeBrechas.nodoEstructuraJerarquica.usuarios" *ngIf="esOwnersGroup(usuario)" [value]="usuario">
                                            {{usuario.nombreCompleto}}
                                        </mat-option>
                                        -->
                                    </mat-select>
                                  </mat-form-field>
                                  <a *ngIf="is_eval_creador" (click)="editar_responsable=true">Editar</a>
                                  <!--<mat-icon *ngIf="(is_owner && analisisDeBrechas?.estado=='PRE_INICIADO') || (is_eval_creador)" aria-hidden="false" aria-label="Editar estado" (click)="editar_dueno=true" >edit</mat-icon>-->
                                </td>
                            </tr>

                            <tr>
                                <td class="label">Fecha finalización</td>
                                <td class="value">
                                  <span *ngIf="!editar_fecha_fin" class="px-20">{{analisisDeBrechas?.fechaFin | date:'dd/MM/yyyy'}}</span>
                                  <mat-form-field color="accent" *ngIf="editar_fecha_fin" fxFlex>
                                  <mat-label>Fecha finalización</mat-label>
                                  <input matInput [matDatepicker]="picker2" [min]="fechaInicio"
                                  [(ngModel)]="fechaFin" (dateChange)="selectFechaFin($event)">
                                  <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                                  <mat-datepicker #picker2></mat-datepicker>
                                  </mat-form-field>
                                  <a *ngIf="(is_eval_creador && analisisDeBrechas?.estado=='PRE_INICIADO')" (click)="editar_fecha_fin=true">Editar</a>
                                  <!--<mat-icon *ngIf="(is_owner && analisisDeBrechas?.estado=='PRE_INICIADO') || (is_eval_creador)" aria-hidden="false" aria-label="Editar estado" (click)="editar_fecha_fin=true" >edit</mat-icon>-->
                                </td>
                            </tr>
                            <tr>
                                <td class="label">Creado por</td>
                                <td class="value"><span class="px-20">{{analisisDeBrechas?.creador?.nombreCompleto}}</span></td>
                            </tr>

                        </table>
                    </div>
                </div>
              </div>
            </div>
            <!-- / CONTENT -->


            <!-- TABS -->

            <div class="content" >

              <!-- <sentencia-tree [dataSource]="this.analisisDeBrechas?.marcoDeReferencia" 
                        [tablaDeAnalisisDeBrechas]="analisisDeBrechas?.tablaDeAnalisisDeBrechas"
                        [analisisDeBrechasEstado]="analisisDeBrechas?.estado"
                        [isResponsable]="is_responsable" 
                        ></sentencia-tree>  -->

                
                <mat-tab-group  *ngFor="let dataSource of this.analisisDeBrechas?.marcoDeReferencia?.sentencias">
                    <mat-tab label="{{dataSource.nombre}}" >
                        <div fxFlex fxLayout="column">
                          <div fxFlex fxLayout="row" fxLayoutAlign="end center">
                            <button  mat-button (click)="viewStatistics(dataSource,1,false)" mat-flat-button color="primary" class="add-row">
                              <mat-icon  aria-hidden="false" aria-label="statistics" >bar_chart</mat-icon>
                            </button>
                            <button  mat-button (click)="viewStatistics(dataSource,0,true)" mat-flat-button color="primary" class="add-row" 
                              *ngIf="analisisDeBrechas?.tablaDeAnalisisDeBrechas.tipo=='EVALUACION_MULTIPLE' && dataSource.sentencias.length >0 && 
                              dataSource.sentencias[0].sentencias !=null && dataSource.sentencias[0].sentencias.length >0 ">
                              <mat-icon  aria-hidden="false" aria-label="statistics" >insert_chart_outlined</mat-icon>
                            </button>
                          </div>
                          <div>
                            <sentencia-tree [dataSource]="dataSource" 
                            [tablaDeAnalisisDeBrechas]="analisisDeBrechas?.tablaDeAnalisisDeBrechas"
                            [analisisDeBrechasEstado]="analisisDeBrechas?.estado"
                            [isResponsable]="is_responsable" 
                            [printable] = "false"
                            (loadData)="updateData()"
                            ></sentencia-tree>  
                          </div>
                      </div>
                        
                    </mat-tab>

                </mat-tab-group>
               

            </div>
            <!-- TABS fin -->

        </div>
        <!-- / CONTENT CARD -->

    </div>
    <!-- / CENTER -->

</div>
